module.exports = __webpack_public_path__ + "media/components/reports/logo-297a37f0df4e31bced34f7b8b03e4236.png";